import { AdminArea } from "../types";
import { apiDomain } from "../utils/climbingAreaUtils";
import { getCachedAdminAreas, setCachedAdminAreas } from "./adminAreasCache";

async function fetchAdminAreas(includeAreas: boolean = false, frontPage: boolean = false, useCache: boolean = true, days?: number): Promise<AdminArea[]> {

    // Check cache first
    if (useCache) {
        const cached = getCachedAdminAreas(includeAreas, frontPage, days);
        if (cached) {
            return cached;
        }
    }

    const baseUrl = new URL("https://" + apiDomain());
    const url = new URL('/country/US/adminArea', baseUrl);

    if (includeAreas) {
        url.searchParams.append('includeAreas', '1');
    }

    if (frontPage) {
        url.searchParams.append('frontPage', '1');
    }

    if (days !== undefined) {
        url.searchParams.append('days', days.toString());
    }

    const response = await fetch(url.toString());
    const adminAreas: AdminArea[] = await response.json();
    if (response.ok && adminAreas) {
        // Cache the result
        setCachedAdminAreas(includeAreas, frontPage, days, adminAreas);
        return adminAreas;
    } else {
        return Promise.reject(new Error(response.statusText));
    }
}

export default fetchAdminAreas;